export class Certificate {
    id: number;
    companyId: string;
    description: string;
    expirationDate: string;
    path: string;
    type: number;
    fileName: string;
    usedOnMobile: string;
    products: string[];
    isAddedByManufacturer: any;

    constructor(currentCertificate: any) {
      this.id = currentCertificate.id;
      this.companyId = currentCertificate.companyId;
      this.description = currentCertificate.description;
      this.expirationDate = currentCertificate.expirationDate;
      this.path = currentCertificate.path;
      this.fileName = currentCertificate.fileName;
      this.type = currentCertificate.type;
      this.usedOnMobile = currentCertificate.usedOnMobile;
      this.products = currentCertificate.products;
      this.isAddedByManufacturer = currentCertificate.isAddedByManufacturer;
    }
}